<template>
  <div id="editStatusLogs">
<section class="toolbar">
         <div class="toolbar-container">
                <router-link id="back-button-edit-logs-status" v-bind:to="'/operator/edit-log?selected_date='+this.$route.query.selected_date+'&from_date=' + this.$route.query.from_date + '&to_date=' + this.$route.query.to_date"><img src="/static/images/back.png"></router-link>
                <h1>{{this.$route.query.status}} | {{this.$route.query.selected_date}}</h1>
         </div>
      </section>
      
      <section class="editlogs">
         <div v-if="showStart" class="editlog-half">
           <span>Start</span>
           <div style="position: relative"><input id="time-start-edit-log" type="text" name="time-start-edit-log" :value="setStartTime"></div>
         </div>
         <div v-else class="editlog-half"><span>Start has been disabled for this entry.</span></div>
         <div v-if="showStop" class="editlog-half editlog-stop">
           <span>Stop</span>
           <div style="position: relative"><input id="time-stop-edit-log" type="text" name="time-stop-edit-log" :value="setStopTime"></div>
         </div>
         <div v-else class="editlog-half editlog-stop"><span>Stop has been disabled for this entry.</span></div>

         <div class="tab-container">
        <div class="group">
          <div class="form-group">
            <label for="time_zone"> Status</label>
            <div class="select-style">
              <select id ="edit_status" v-model="logStatus" name="edit_status">
                <option id="edit-on" value="on">on</option>
                <option id="edit-off" value="off">off</option>
                <option id="edit-sb" value="sb">sb</option>
                <option id="edit-driving" value="driving">driving</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="comment">Reason</label>
        <textarea class="form-control" rows="5" id="annotation" v-model="note"></textarea>
      </div>
      <div class="edit-warning">By editing logs you self-certify this edit with the reason mentioned above as per the FMCSA guidelines</div>

      </section>
      
      <section class="submit-section">
         <button class="btn btn-default" @click="updateCall()">Save</button>
         <!-- <button class="btn btn-default">Cancel</button> -->
      </section>
      
      
  </div>
</template>

<script>
export default {
  name: "editStatusLogs",
  template: "#editStatusLogs",
  data: () => ({
    originalStartTime: "",
    originalStopTime: "",
    setStartTime: "",
    setStopTime: "",
    startLimit: "",
    stopLimit: "",
    logStatus: "",
    note: "",
    showStart: true,
    showStop: true
  }),
  mounted: function() {
    this.logStatus = this.$route.query.status;
    this.note = this.$route.query.annotation;
    this.originalStartTime = this.$route.query.startTime;
    this.originalStopTime = this.$route.query.stopTime;
    this.setStartTime = this.$route.query.startTime;
    this.setStopTime = this.$route.query.stopTime;
    this.startLimit = this.$route.query.startLimit;
    this.stopLimit = this.$route.query.stopLimit;
    this.controlStartStop();
    this.controlShiftCriticalStartStop();
    var self = this;
    $("#time-start-edit-log")
      .datetimepicker({
        // use24hours: true,
        format: "HH:mm:ss",
        ignoreReadonly: true
        // debug: true,
      })
      .on("dp.change", function(e) {
        self.setStartTime = $("#time-start-edit-log").val();
      });
    $("#time-stop-edit-log")
      .datetimepicker({
        // use24hours: true,
        format: "HH:mm:ss",
        ignoreReadonly: true
        // debug: true,
      })
      .on("dp.change", function(e) {
        self.setStopTime = $("#time-stop-edit-log").val();
      });
    // .on('dp.change', function(e){
    //     self.inspectionTime = $('#time').val();
    // });
  },
  methods: {
    timeChecker: function() {
      var self = this;
      var moment = require("moment");
      var changed_start = moment(self.setStartTime, "HH:mm:ss");
      var changed_stop = moment(self.setStopTime, "HH:mm:ss");
      var original_start = moment(self.originalStartTime, "HH:mm:ss");
      var original_stop = moment(self.originalStopTime, "HH:mm:ss");
      var start_limit = moment(self.startLimit, "HH:mm:ss");
      var stop_limit = moment(self.stopLimit, "HH:mm:ss");
      //use momentjs
      if (changed_start >= changed_stop) {
        self.setStartTime = self.originalStartTime;
        self.setStopTime = self.originalStopTime;
        alert(
          "You cannot push the start/stop time beyond it's opposite. The Start and stop time have been reset to their original times."
        );
        return { result: false };
      }
      if (changed_stop.diff(stop_limit, "seconds") > 0 && self.stopLimit != 0) {
        self.setStartTime = self.originalStartTime;
        self.setStopTime = self.originalStopTime;
        alert(
          "You cannot push the stop time beyond the shift start/stop. The Start and stop time have been reset to their original times!"
        );
        return { result: false };
      }
      if (
        changed_start.diff(start_limit, "seconds") < 0 &&
        self.startLimit != 0
      ) {
        self.setStartTime = self.originalStartTime;
        self.setStopTime = self.originalStopTime;
        alert(
          "You cannot push the start time beyond the shift start/stop. The Start and stop time have been reset to their original time!!"
        );
        return { result: false };
      }
      if (
        changed_start.diff(original_start, "seconds") != 0 &&
        changed_stop > original_stop
      ) {
        return {
          shift: "positive",
          result: true,
          difference_stop_start: changed_stop.diff(changed_start, "seconds"),
          difference_start: changed_start.diff(original_start, "seconds"),
          difference_stop: changed_stop.diff(original_stop, "seconds")
        };
      }
      if (
        changed_start.diff(original_start, "seconds") != 0 &&
        changed_stop < original_stop
      ) {
        return {
          shift: "negative",
          result: true,
          difference_stop_start: changed_stop.diff(changed_start, "seconds"),
          difference_start: changed_start.diff(original_start, "seconds"),
          difference_stop: changed_stop.diff(original_stop, "seconds")
        };
      }
      if (
        changed_start.diff(original_start, "seconds") == 0 &&
        changed_stop.diff(original_stop, "seconds") != 0
      ) {
        return {
          shift: "stopside",
          result: true,
          difference_stop_start: changed_stop.diff(changed_start, "seconds"),
          difference_start: changed_start.diff(original_start, "seconds"),
          difference_stop: changed_stop.diff(original_stop, "seconds")
        };
      }
      if (
        changed_start.diff(original_start, "seconds") != 0 &&
        changed_stop.diff(original_stop, "seconds") == 0
      ) {
        return {
          shift: "startside",
          result: true,
          difference_stop_start: changed_stop.diff(changed_start, "seconds"),
          difference_start: changed_start.diff(original_start, "seconds"),
          difference_stop: changed_stop.diff(original_stop, "seconds")
        };
      }
      if (
        (self.logStatus != self.$route.query.status ||
          self.note != self.$route.query.annotation) &&
        (changed_start.diff(original_start, "seconds") == 0 &&
          changed_stop.diff(original_stop, "seconds") == 0)
      ) {
        return { shift: "status", result: true };
      }
      self.setStartTime = self.originalStartTime;
      self.setStopTime = self.originalStopTime;
      alert(
        "The start and stop times have not been changed or a discrepancy in the times has been detected."
      );
      return { result: false };
    },
    controlStartStop: function() {
      var self = this;
      if (self.$route.query.index == 0) {
        self.showStart = false;
      }
      if (self.$route.query.index == self.$route.query.len) {
        self.showStop = false;
      }
    },
    controlShiftCriticalStartStop: function() {
      var self = this;
      if (self.$route.query.before_shift_critical == 1) {
        self.showStop = false;
      }
      if (self.$route.query.after_shift_critical == 1) {
        self.showStart = false;
      }
    },
    updateCall: function() {
      var self = this;
      var check = self.timeChecker();
      console.log(check);
      if (check.result) {
        self.$config.loading = true;
        $.ajax({
          url: self.$config.API + "/v1/operator/edit-status-log",
          type: "POST",
          crossDomain: true,
          data: {
            annotation: self.note,
            duty_status: self.logStatus,
            from_date: self.$route.query.from_date,
            to_date: self.$route.query.to_date,
            selected_date: self.$route.query.selected_date,
            shift: check.shift,
            difference_stop_start: check.difference_stop_start,
            difference_start: check.difference_start,
            difference_stop: check.difference_stop,
            log_id: self.$route.query.logId,
            index: self.$route.query.index
          },
          xhrFields: {
            withCredentials: true
          },
          timeout: 10000,
          success: function(res) {
            self.$config.loading = false;
            alert("Logs updated successfully.");
            self.$router.push(
              "/operator/edit-log?selected_date=" +
                self.$route.query.selected_date +
                "&from_date=" +
                self.$route.query.from_date +
                "&to_date=" +
                self.$route.query.to_date
            );
          },
          error: function(res) {
            self.$config.loading = false;
            alert("Update Failed.");
          }
        });
      } else {
      }
    }
    // call: function() {
    //   var self = this;
    //   self.$config.loading = true;
    //   $.ajax({
    //     url: "",
    //     type: "GET",
    //     crossDomain: true,
    //     data: {},
    //     xhrFields: { withCredentials: true },
    //     timeout: 10000,
    //     success: function() {
    //       self.$config.loading = false;
    //     },
    //     error: function() {
    //       self.$config.loading = false;
    //     }
    //   });
    // }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/editStatusLogs.vue